import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useFavorites } from '../../context/FavoritesContext';
import { useCart } from '../../context/CartContext';
import { fetchProductsByIds } from '../../api/product';
import './Wishlist.css';

export default function WishlistPage() {
  const { ids, remove, toggle, has } = useFavorites();
  const { add } = useCart();
  const [items, setItems] = useState([]);

  useEffect(() => {
    let ok = true;
    (async () => {
      if (!ids.length) { if (ok) setItems([]); return; }
      const data = await fetchProductsByIds(ids);
      if (ok) setItems(data || []);
    })();
    return () => { ok = false; };
  }, [ids]);

  if (!ids.length) {
    return (
      <div className="page container">
        <h1>Избранное</h1>
        <p>Список пуст. <Link to="/catalog">Перейти в каталог</Link></p>
      </div>
    );
  }

  return (
    <div className="page container">
      <h1>Избранное</h1>

      <div className="wl-grid">
        {items.map(p => {
          const pid = String(p._id);
          return (
            <div className="wl-card" key={pid}>
              <Link to={`/p/${p.slug}`} className="wl-thumb">
                {p.image ? <img src={p.image} alt={p.title} /> : <div className="noimg" />}
              </Link>

              <Link to={`/p/${p.slug}`} className="wl-title">{p.title}</Link>
              <div className="wl-price">{p.price?.effective?.toLocaleString('ru-RU')} ₽</div>

              <div className="wl-actions">
                {/* В КОРЗИНУ — НЕ УДАЛЯЕТ из избранного */}
                <button
                  className="btn-primary"
                  onClick={() => add({ _id: pid, slug: p.slug, title: p.title, images: [{ url: p.image }], price: p.price }, 1)}
                >
                  В корзину
                </button>

                {/* Отдельная кнопка убрать из избранного */}
                <button className="btn-outline" onClick={() => remove(pid)}>Убрать</button>

                {/* Альтернативно — одна кнопка-сердце */}
                <button
                  className={`btn-outline ${has(pid) ? 'is-active' : ''}`}
                  title={has(pid) ? 'Убрать из избранного' : 'В избранное'}
                  onClick={() => toggle(pid)}
                >
                  ♥
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
